import React from 'react';
import CustomerSummary from './CustomerSummary';
import { Outlet } from 'react-router-dom';

export default function CustomerDetail() {
  return (
    <section>
      <div className="ui grid">
        <div className="four wide column">
          <CustomerSummary />
        </div>
        <div className="twelve wide column">
          <Outlet />
        </div>
      </div>
    </section>
  );
}
